import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "./personalLayout/PersonalSidebar";
import Header from "./personalLayout/PersonalHeader";
import { Outlet } from "react-router-dom";

export default function PersonalLayout() {
  return (
    <Container fluid>
      <Row>
        <Col md={3} lg={2} className="sidebar">
          <Sidebar />
        </Col>
        <Col md={9} lg={10} className="ms-sm-auto px-md-0 d-flex flex-column">
          <Header />
          <main className="content flex-fill">
            <Outlet />
          </main>
        </Col>
      </Row>
    </Container>
  );
};
